import React from "react";
import '../pl-error-boundary.scss';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import UIButton from '../../UI/UIButton/UIButton';
import { sessionRoutes } from '../../../utils/Config/SessionConfig';
import { getSignedInUserSelector } from "../../../redux/selectors/CurrentUserSelectors";
import { PLPermissionBoundaryProps } from "./types";

const PLPermissionBoundary = ({ isGranted, className, children }: PLPermissionBoundaryProps) =>{
	const signedInUser = useSelector(getSignedInUserSelector);

	const history = useHistory();

	const navigateHome = () => {
		let pushRoute = '/';
		if (signedInUser) {
			const roleRoutes = sessionRoutes(signedInUser).filter(({ showInPanel, skipInitial }) => showInPanel && !skipInitial);
			if (roleRoutes.length > 0) {
				pushRoute = roleRoutes[0].path;
			}
		}
		history.push(pushRoute);
	}

	if (!isGranted) {
		return (
			<div className='errorBody'>
				<img
					className='logo'
					alt='pineapple labs logo'
					src='https://res.cloudinary.com/pineapple-labs/image/upload/v1583271353/pl-assets/pl-logo-alt/pl-alt-logo-dark/pl-alt-logo-dark_312h_nzdbcf.png'
					width='400'
				/>
				<p className='page-title'>You don't have permission to view this page!</p>

				<div className='errorBody__buttons'>
					<UIButton
						type={UIButton.FILL_TYPE}
						text={'take me home'}
						onClick={navigateHome}
					/>
				</div>
				<div>
					<p className='errorBody__chat'>
						<p className='page-title'>Need Help?</p>
						<p className='errorBody__chat--text'>
							Our Chat is here to help! Click on our Chat button on the bottom right of this page to reach us for assistance.
						</p>
					</p>
				</div>
			</div>
		);
	}

	if (className) {
		return <div className={className}>{children}</div>;
	}

	return children;
}
export default PLPermissionBoundary
